import axios from 'axios';

const v1ApiWalletBaseURL = '/api/wallet/v1', // relative path
	history = (historyType, page = 1, type = 'all', serviceCode = 'all', count = 10, transactionId = '') => {
		if (historyType === 'non-nx') {
			return axios.get(`${v1ApiWalletBaseURL}/history/non-nx`, {
				params: {
					page,
					count,
					...(environment.region === 'tw' ? { orderType: 'direct' } : {}),
					...(page > 1 && transactionId && { transactionId }),
				},
				withCredentials: true,
			});
		}
		return axios.get(`${v1ApiWalletBaseURL}/history`, {
			params: {
				page,
				count,
				type,
				...(environment.region !== 'global' ? { serviceCode } : {}),
			},
			withCredentials: true,
		});
	},
	getNonNxTaxInfo = (transactionId) =>
		axios.get(`${v1ApiWalletBaseURL}/history/non-nx/transactions/${transactionId}`, { withCredentials: true }),
	getBalance = () => axios.get(`${v1ApiWalletBaseURL}/balance`, { withCredentials: true }),
	getProducts = (params = {}) => axios.get(`${v1ApiWalletBaseURL}/products`, { params, withCredentials: true }),
	getCheckoutToken = (params = {}) => axios.post(`${v1ApiWalletBaseURL}/checkout`, params, { withCredentials: true }),
	getEpinNexonCardsToken = (params = {}) => axios.post(`${v1ApiWalletBaseURL}/checkout/methods/epin`, params, { withCredentials: true }),
	getRecentPurchaseDate = (params = {}) => axios.get(`${v1ApiWalletBaseURL}/transactions/recent-date`, params, { withCredentials: true }),
	getTWStatusCheck = () => axios.get(`${v1ApiWalletBaseURL}/maintenance/method`, { withCredentials: true }),
	WalletAPI = {
		install(Vue) {
			Vue.prototype.$walletAPI = {
				history,
				getNonNxTaxInfo,
				getProducts,
				getBalance,
				getCheckoutToken,
				getEpinNexonCardsToken,
				getRecentPurchaseDate,
				getTWStatusCheck,
			};
		},
	};

export default WalletAPI;
export { history, getBalance, getProducts, getCheckoutToken, getEpinNexonCardsToken, getTWStatusCheck };
